import classNames from 'classnames';
import React from 'react';

interface FormulaIconProps {
  className?: string;
}

export default function FormulaIcon({className}: FormulaIconProps): JSX.Element {
  return (
    <span className={classNames('fx-icon', className)}>
      ƒ<sub>x</sub>
    </span>
  );
}
